import React, { useState } from 'react';
import { CustomButton } from './button.jsx';
import { AreaInput } from './text_area_input.jsx';
import { NumInput } from './general_num_input.jsx';
import {KONE_PARTS_URL} from '../../assets/links';
import  SelectDropdown  from './select_dropdown.jsx';
import { v4 as uuidv4 } from "uuid";
import _ from 'underscore';
import PreviousResponse from '../../components/previous-response/previous_response.jsx';

const maxPsrPackets = 2
const maxMaterials = 2
const areaInputMaxLenght = "50"
const additionalInfoMaxLenght = "255"
const numberInputMaxLenght = 2
const numberInputMin = "0"
const numberInputMax = "99"
const integerValidator = (input) => {
  return /^\d+$/.test(input)
}

const MaterialLead = ({item, previousItem, onPlannerLeadChanged, selection, translations, responseHeader, index, addPackageUrl}) => {

  const idIndex = index+1

  return (
    <div>
      <h2 className="head">{translations?.material?.newMaterialHeader} {idIndex}</h2>
      {
        previousItem?.name && <PreviousResponse responseHeader={responseHeader} responseText={previousItem.name} />
      }
      <AreaInput
        id={'materialInput'+idIndex}
        label={translations?.material?.newMaterialLabel}
        helpText={translations?.material?.newMaterialHelpText}
        onInputChange={(change) => onPlannerLeadChanged(selection, "material-name", {id:item.id, value:change}) }
        value={item.name}
        maxLength={areaInputMaxLenght}
        placeHolder={translations?.material?.placeholder}
        mandatory={false}
      />
      <p 
        className='parts-url'
        onClick={() => {window.open(addPackageUrl)}}
      >
        {translations?.general?.goToPartsList + ' >'}
      </p>
      {
        previousItem?.quantity && Number(previousItem.quantity) > 0 ? (
          <PreviousResponse
            responseHeader={responseHeader}
            responseText={previousItem.quantity}
          />
        ) : null
      }
      <NumInput
        id={'materialQuantity'+idIndex}
        label={translations?.general?.quantity}
        min={numberInputMin}
        max={numberInputMax}
        units={"METRIC"}
        labelDetail=""
        maxLength={numberInputMaxLenght}
        onInputChange={(valueObj) => onPlannerLeadChanged(selection, "material-quantity", {id:item.id, value:valueObj.value})}
        value={item.quantity}
        valid={true}
        validityTester={(input) => integerValidator(input)}
        helpText=""
        mandatory={false}
      />
      <CustomButton
        text={translations?.general?.delete}
        onButtonClick={() => onPlannerLeadChanged(selection, "material-delete", {id:item.id})}
        customClasses="standard-btn orange add-packet"
        id={'deleteMaterial'+idIndex}
      />
    </div>
  )

}

const PsrPackage = ({item, previousItem, onPlannerLeadChanged, psrPackageUrl, selection, translations, responseHeader, index}) => {

  const idIndex = index+1

  return(
    <div>
      <h2 className="head">{translations?.psrPackage?.newPsrPacketHeader} {idIndex}</h2>
      {
        previousItem?.name && <PreviousResponse responseHeader={responseHeader} responseText={previousItem.name} />
      }
      <AreaInput
        id={'psrInput'+idIndex}
        label={translations?.psrPackage?.newPsrPacketLabel}
        helpText={translations?.psrPackage?.newPsrPacketHelpText}
        onInputChange={(change) => onPlannerLeadChanged(selection, "psr-name", {id:item.id, value:change}) }
        value={item.name}
        maxLength={areaInputMaxLenght}
        placeHolder={translations?.psrPackage?.placeholder}
        mandatory={false}
      />
      <p 
        className='parts-url'
        onClick={() => {window.open(psrPackageUrl)}}
      >
        {translations?.general?.goToPartsList + ' >'}
      </p>
      {
        previousItem?.quantity && Number(previousItem.quantity) > 0 ? (
          <PreviousResponse
            responseHeader={responseHeader}
            responseText={previousItem.quantity}
          />
        ) : null
      }

      <NumInput
        id={'psrQuantity'+idIndex}
        label={translations?.general?.quantity} 
        min={numberInputMin}
        max={numberInputMax}
        units={"METRIC"}
        labelDetail=""
        maxLength={numberInputMaxLenght}
        onInputChange={(valueObj) => onPlannerLeadChanged(selection, "psr-quantity", {id:item.id, value:valueObj.value})}
        value={item.quantity}
        valid={true}
        validityTester={(input) => integerValidator(input)}
        helpText=""
        mandatory={false}
      />
      <CustomButton
        text={translations?.general?.delete}
        onButtonClick={() => onPlannerLeadChanged(selection, "psr-delete", {id:item.id})}
        customClasses="standard-btn orange add-packet"
        id={'deletePsrPacakge'+idIndex}
      />
    </div>
  )

}


const PlannerLead = (props) => {
  const {
    id,
    onPlannerLeadChanged,
    previousPlannerLead,
    plannerLead,
    psrPackageUrl,
    selection,
    translations,
    responseHeader,
    relatedQuestionTranslation
  } = props;

  const newItemTemplate = () => {
    return {
      id: uuidv4(),
      name: "",
      quantity: ""
    }
  }

  const shouldBeDisabled = (count, leadList) => leadList && leadList.length >= count ? true : false
  
  const calculateSelectedPacakges = (pkg) => pkg ? pkg.length : 0

  const additionalInfoMandatory = () => {
    let returnValue = true
    // If any material or PSR package is missing name field, then additional comments is mandatory
    
    if(plannerLead?.materials){
      plannerLead.materials.forEach(item => {
        !item.name || item.name === "" ? returnValue = false : null
      });
    }
    if(plannerLead?.psrPackages){
      plannerLead.psrPackages.forEach(item => {
        !item.name || item.name === "" ? returnValue = false : null
      });
    }
    
    // If plannerLead is empty, then at least additional comments is mandatory
    if((!plannerLead?.materials || plannerLead?.materials.length < 1) 
      && (!plannerLead?.psrPackages || plannerLead?.psrPackages.length < 1 )){
      returnValue = false
    }
    return returnValue
  }



  return (
    <div id={selection+"PlannerLead"} className="planner-lead">
     <h2 id={id} className="head">{translations?.general?.plannerLeadHeader}</h2>
     {relatedQuestionTranslation && <div className="lead-instruction-option-selected">{relatedQuestionTranslation}</div>}
     <div className="lead-instruction-text">{translations?.general?.plannerInstructionText}</div>
      <CustomButton
        text={translations?.psrPackage?.newPsrPacketButtonText + ' ' + calculateSelectedPacakges(plannerLead?.psrPackages) + `/${JSON.stringify(maxPsrPackets)}`}
        onButtonClick={() => onPlannerLeadChanged(selection, "new_psr", newItemTemplate())}
        disabled={shouldBeDisabled(maxPsrPackets, plannerLead?.psrPackages)}
        id={selection+"newPsrPackageButton"}
        customClasses="standard-btn light-blue"
      />
       {plannerLead && plannerLead.psrPackages.length > 0 && 
        plannerLead.psrPackages.map( (item, key) => 
          <PsrPackage
            previousItem={previousPlannerLead?.psrPackages ? previousPlannerLead.psrPackages[key] : {}}
            item={item}
            key={key}
            psrPackageUrl={psrPackageUrl}
            onPlannerLeadChanged={onPlannerLeadChanged}
            selection={selection}
            translations={translations}
            responseHeader={responseHeader}
            index={key}/>
        )}
      <CustomButton
        text={translations?.material?.newMaterialButtonText + ' ' + + calculateSelectedPacakges(plannerLead?.materials) + `/${JSON.stringify(maxMaterials)}`}
        onButtonClick={() => onPlannerLeadChanged(selection, "new_material", newItemTemplate())}
        disabled={shouldBeDisabled(maxMaterials, plannerLead?.materials)}
        id={selection+"NewMaterialButton"}
        customClasses="standard-btn light-blue"
      />
      {plannerLead && plannerLead.materials.length > 0 && 
        plannerLead.materials.map( (item, key) => 
          <MaterialLead
            previousItem={previousPlannerLead?.materials ? previousPlannerLead.materials[key] : {}}
            item={item}
            key={key}
            onPlannerLeadChanged={onPlannerLeadChanged}
            selection={selection}
            translations={translations}
            responseHeader={responseHeader}
            addPackageUrl={psrPackageUrl}
            index={key}/>
        )}
      {plannerLead && plannerLead.materials.length > 0 &&
        <>
          <SelectDropdown
            id={selection+"LabourHours"}
            strings={[]}
            title={translations?.general?.labourHours}
            // Need to give value inside object as this is how Dropdown component has been developed
            value={plannerLead?.labourHours ? {value: plannerLead.labourHours} : ""}
            // underscore to generate options list from 0.5-20
            options={_.range(0.5, 20.5, 0.5)}
            onValueChange={(valueObj) => onPlannerLeadChanged(selection, "labour-hours", valueObj)}
            default={translations?.general?.selectLabourHours}
            // Need to give this object even though we don't need it.
            other={{
              otherOption: undefined,
              otherText: undefined,
              otherField: undefined, //true or false
              otherFieldTitle: undefined
            }}
            mandatory={false}
            lastSurveyResponseHeader={responseHeader}
            lastSurveyResponseText={previousPlannerLead?.labourHours || null}
          />
        </>
      }
      <h2 className="head">{translations?.general?.additionalInfo} {/*!additionalInfoMandatory() && <span className="mandatory-asterix"> *</span>*/}</h2>
      {
        previousPlannerLead?.additionalComments && <PreviousResponse responseHeader={responseHeader} responseText={previousPlannerLead?.additionalComments} />
      }
      <AreaInput
        id={selection+"AdditionalInfo"}
        label=""
        helpText={translations?.general?.additionalInfoHelpText}
        onInputChange={(change) => onPlannerLeadChanged(selection, "addittional-comments", {value: change})}
        value={plannerLead?.additionalComments || ""}
        maxLength={additionalInfoMaxLenght}
      />
    </div>
  );


};

export default PlannerLead;
